import React from 'react'

export default function CurrentImagePreview({
  url,
  alt,
  label = 'Current Image',
  className = 'h-24 w-24 rounded-lg object-cover'
}) {
  if (!url) return null

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      <img src={url} alt={alt} className={className} />
    </div>
  )
}
